import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {
  AccountCreationSteps,
  FinancialAccountsCreationService
} from "@brightside-web/desktop/feature/financial-accounts-core";
import {LoanPartner, NewLoansService} from "../new-loans.service";
import {Observable} from "rxjs";

@Component({
    selector: 'brightside-web-loan-verification',
    templateUrl: './loan-verification.component.html',
    styleUrls: ['./loan-verification.component.css'],
    standalone: false
})
export class LoanVerificationComponent {

  loanPartnerInfo: Observable<LoanPartner> = this.newLoanSvc.partnerInfo;

  productType: string;
  routeOnSuccess = ['../consents'];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private newLoanSvc: NewLoansService,
    private faCreateSvc: FinancialAccountsCreationService
  ) {}

  submitAction() {
    this.faCreateSvc.advanceStep(AccountCreationSteps.VERIFICATION);
    this.router.navigate(this.routeOnSuccess, { relativeTo: this.route });
  }

}
